var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form", [
    _c(
      "div",
      {
        staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 my-4",
        class: _vm.styleClass,
      },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _c("div", { staticClass: "md:col-span-1" }, [
            _c(
              "h3",
              { staticClass: "text-lg font-medium leading-6 text-gray-900" },
              [_vm._v(" " + _vm._s(_vm.title) + " ")]
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.body,
                    expression: "body",
                  },
                ],
                staticClass: "mt-1 text-sm leading-5 text-gray-500",
              },
              [_vm._v(" " + _vm._s(_vm.body) + " ")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "mt-5 md:mt-0 md:col-span-2" },
            [_vm._t("default")],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }